__turbopack_context__.v({
  "appear-slide-left": "CoopCard-module-scss-module__p128uG__appear-slide-left",
  "bounceTwice": "CoopCard-module-scss-module__p128uG__bounceTwice",
  "card": "CoopCard-module-scss-module__p128uG__card",
  "container": "CoopCard-module-scss-module__p128uG__container",
  "content": "CoopCard-module-scss-module__p128uG__content",
  "fade-in-bottom": "CoopCard-module-scss-module__p128uG__fade-in-bottom",
  "fade-in-left": "CoopCard-module-scss-module__p128uG__fade-in-left",
  "fade-in-right": "CoopCard-module-scss-module__p128uG__fade-in-right",
  "fadeIn": "CoopCard-module-scss-module__p128uG__fadeIn",
  "loader": "CoopCard-module-scss-module__p128uG__loader",
  "puff-in-center": "CoopCard-module-scss-module__p128uG__puff-in-center",
  "puff-in-left": "CoopCard-module-scss-module__p128uG__puff-in-left",
  "pulse": "CoopCard-module-scss-module__p128uG__pulse",
  "pulse-contact": "CoopCard-module-scss-module__p128uG__pulse-contact",
  "shake-bottom": "CoopCard-module-scss-module__p128uG__shake-bottom",
  "slide-again": "CoopCard-module-scss-module__p128uG__slide-again",
  "slide-in-right": "CoopCard-module-scss-module__p128uG__slide-in-right",
  "stepContent-entrance": "CoopCard-module-scss-module__p128uG__stepContent-entrance",
});
